import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import FormContext from './FormContext'
import FormSuspense from 'src/components/Forms/FormSuspense'
import Form from './Form'

interface CopyModelProps {
  id: string
  isOpen: boolean
  toggle: () => void
}

const CopyModel: React.FC<CopyModelProps> = (props) => {
  const { id, isOpen, toggle } = props

  return (
    <Modal
      title='Copy Candidate'
      isOpen={isOpen}
      toggle={toggle}
    >
      <Header title='Copy Candidate' />
      <FormSuspense fallback={<Form toggle={toggle} disableSave />}>
        <FormContext id={id} toggle={toggle} />
      </FormSuspense>
    </Modal>
  )
}

export default CopyModel
